import { createFileRoute } from "@tanstack/react-router";

import { CreateWhitelabelConfigPage } from "@/features/whitelabel/CreateWhitelabelConfigPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/whitelabel/create")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Create Whitelabel Config");

  return <CreateWhitelabelConfigPage />;
}
